export const PRIMARY = 'primary' as const;
export const SECONDARY = 'secondary' as const;
export const DARK_GREY = 'darkGrey' as const;
export const GREY = 'grey' as const;
export const LIGHT_GREY = 'lightGrey' as const;
export const BLACK = 'black' as const;
export const WHITE = 'white' as const;
export const BLUE = 'blue' as const;

export const COLORS = {
  PRIMARY,
  SECONDARY,
  DARK_GREY,
  GREY,
  LIGHT_GREY,
  BLACK,
  WHITE,
  BLUE,
};

export type COLOR =
  | typeof PRIMARY
  | typeof SECONDARY
  | typeof DARK_GREY
  | typeof GREY
  | typeof LIGHT_GREY
  | typeof BLACK
  | typeof WHITE
  | typeof BLUE;

export type ColorsInterface = Record<COLOR, string>;
